import { useMemo } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { TextFieldProps } from '@material-ui/core/TextField';
import { InputProps } from '@material-ui/core/Input';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

import { useForm, useFormRefs, useGTranslation } from '../hooks';

import { useStyles as useFormFileStyles } from './FormFile';
import FormInput from './FormInput';

const FormDateTextField: React.FC<TextFieldProps> = ({ InputProps: { id, name, ...InputProps } = {}, helperText, ...rest }) => {
	const form = useForm();
	const refs = useFormRefs();

	const classes = useFormFileStyles();
	const translate = useGTranslation();
	const cd = translate("form.chooseDate");

	const date = useMemo(() => form.values[id!], [form.values[id!]]);
	const value = useMemo(() => date ? rest.value : cd, [date, cd]);

	return (
		<FormInput
			id={id!}
			description={name!}
			endAdornment={(
				<IconButton
					onClick={() => (refs.current[id!] as HTMLInputElement).focus()}
					color="primary"
					className={classes.iconButton}
				>
					<CalendarTodayIcon className={classes.svg} />
				</IconButton>
			)}
			{...InputProps}
			{...rest as InputProps}
			value={value}
		/>
	);
}

export default FormDateTextField;